import { changeUserActivationStatus } from "../../Pages/AdminCourseManagement/Fills";
import { changeCourseListUserCounter } from "../../Pages/AdminCourseManagement/UserCounters";
import { ajaxRequest } from "../Ajax/ajax";
import { successToast } from "../utils";

export var deactivateUser = function(userId, courseId, element){

    const success = function(data){
        successToast("Schüler/-in wurde erfolgreich deaktiviert ", "Erfolg", 4500, true);
        changeCourseListUserCounter(-1);
        changeUserActivationStatus(element);
    }

    const data = {}

    const url = '/course/' + courseId.toString() + '/user/' + userId.toString() + '/deactivate'

    ajaxRequest(url, success, data, element);

  }